/**
 * Checks if a given date is within the last 30 days from now
 * @param createdDate - ISO date string representing when content was created
 * @returns true if the content was created within the last 30 days, false otherwise
 */
export const isPageCreatedIn30Days = (createdDate: string | null): boolean => {
	if (!createdDate) {
		return false;
	}

	try {
		const createdTime = new Date(createdDate).getTime();
		const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

		return createdTime > thirtyDaysAgo;
	} catch (error) {
		// Invalid date string
		return false;
	}
};
